import { render, staticRenderFns } from "./Definition.vue?vue&type=template&id=2ba70a94&"
import script from "./Definition.vue?vue&type=script&lang=js&"
export * from "./Definition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports